import * as FileSaver from 'file-saver';
import { Button } from 'reactstrap';
import { toCsv } from '../../utils/csv';
import { exportFileName } from '../../utils/utils';

const TableCsvButton = ({ title, data, cols, ...buttonProps }) => {
  const onClick = () => {
    const csvData = toCsv(data, cols);
    const csv = new Blob([csvData], {
      type: 'text/csv',
    });
    FileSaver.saveAs(csv, exportFileName(title, 'csv'));
  };
  return (
    <Button onClick={onClick} {...buttonProps}>
      Export CSV
    </Button>
  );
};

export default TableCsvButton;
